import axios from "axios";
import { api } from "./axios.config";
import { TimezoneUtils } from "../revampPages/ManageEvents/Reports/AccountLevelReportConstant";

const API_URL = api.apiUrl;

export const getOrganiserEventCurrencies = () => {
    return axios.get(API_URL + "/organiser/event/currencies");
};
export const getOrganiserReports = (params) => {
    const timezoneData = TimezoneUtils.getTimezoneData();

    const enhancedParams = {
        ...params,
        time_offset: timezoneData.offsetMinutes
    };
    return axios.get(`${API_URL}/organiser/reports`,  { params: enhancedParams });
};